import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset, change } from 'redux-form';
import CalculatorDialog from './CalculatorDialog';
import { IApplicationState } from 'ducks/reducers';

const formName = 'CalculatorDialogForm';

const mapStateToProps = (state: IApplicationState) => ({
  dirty: isDirty(formName)(state),
  values: getFormValues(formName)(state),
  isValid: isValid(formName)(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset(formName),
    changeFormFieldValue: (fieldName: string, fieldValue: any) => change(formName, fieldName, fieldValue),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CalculatorDialog);
